import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { suggestionActions } from 'store/data/suggestion';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches improvement suggestions and loads the suggestion domain.
// Gated behind JwtFeature.Improvements.
export function* initializeSuggestions() {
  function* work(tenantId: string) {
    const { suggestionDomain }: SagaReturnType<typeof api.getSuggestions> =
      yield call(api.getSuggestions, { tenantId });

    yield put(suggestionActions.setDomain(suggestionDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Improvements);
}
